import { TbSearch } from "react-icons/tb";

const Loading = () => {
    return (
        <>
            <div className="text-center my-16">
                <TbSearch className="text-4xl mx-auto mb-3" />
                <p>Search City Name</p>
            </div>

        </>
    )
}

export default Loading;